import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// SPPO CREATION APIs
// Legacy route: /Purchase/SPPOCreation
// Note: sppoApi.js in this same folder backs the *verification* page and is
// registered under the "sppo" store key — this file is the creation-side
// counterpart with its own slice/store key ("sppoCreation").
// ==============================================

const get = async (path, params, errMsg) => {
    try {
        const queryParams = new URLSearchParams(params || {});
        const qs = queryParams.toString();
        const response = await axios.get(
            `${API_BASE_URL}${path}${qs ? `?${qs}` : ''}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error(`❌ ${errMsg}:`, error.response || error);
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};

export const getVendorsForSPPO = () =>
    get('/Purchase/GetVendorsForSPPO', {}, 'Get Vendors For SPPO API Error');

export const getBudgetCCForSPPO = () =>
    get('/Purchase/GetBudgetCCForSPPO', {}, 'Get Budget CC For SPPO API Error');

export const getDCAByCCForSPPO = (ccCode) =>
    get('/Purchase/GetDCAByCCForSPPO', { CCCode: ccCode }, 'Get DCA By CC For SPPO API Error');

export const getSubDCAbyDCA = (dcaCode) =>
    get('/Accounts/GetSubDCAbyDCA', { DCACode: dcaCode }, 'Get Sub DCA By DCA API Error');

export const getUpdloadDocSPPOValue = (ccCode) =>
    get('/Purchase/UpdloadDocSPPOValue', { CCCode: ccCode }, 'Get Upload Doc SPPO Value API Error');

export const saveNewServiceProvider = async (payload) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/Purchase/SaveNewServiceProvider`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Save New Service Provider PO API Error:', error.response || error);
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};
